export const REPORT_TYPES = {
  BARBER: 'barber',
  LOCATION: 'location',
};

export const SET_REPORT_DEFINITIONS = 'SET_REPORT_DEFINITIONS';
export const SET_REPORT_DEFINITIONS_ERROR = 'SET_REPORT_DEFINITIONS_ERROR';
export const SET_REPORT_DEFINITION = 'SET_REPORT_DEFINITION';
export const SET_METRICS_DEFINITIONS = 'SET_METRICS_DEFINITIONS';
export const DELETE_REPORT_DEFINITION = 'DELETE_REPORT_DEFINITION';
export const SET_REPORT_DATA = 'SET_REPORT_DATA';
export const RESET_REPORT_DATA = 'RESET_REPORT_DATA';

export const INIT_FILTER = 'INIT_FILTER';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const FILTER_SELECT_ALL = 'FILTER_SELECT_ALL';
export const FILTER_DESELECT_ALL = 'FILTER_DESELECT_ALL';
export const SET_FILTERS_DIRTY = 'SET_FILTERS_DIRTY';

export const CUSTOM_REPORTS_PATH = '/reports/custom';
